import {
  Text,
  Title,
  Button,
  Box,
  Badge,
} from "@mantine/core";
import image from "../public/whatsapp-reminder3.webp";
import { MediaStage } from "./MediaStage";
import classes from "../styles/Section_whatsapp_reminder.module.css";
import { IconCheck, IconBolt, IconBrandWhatsapp, IconBellRinging, IconMessageChatbot, IconSend } from "@tabler/icons";

export function Section_whatsapp_reminder() {
  const benefits = [
    { text: "פחות ביטולים ברגע האחרון", icon: <IconBrandWhatsapp size={18} /> },
    { text: "אישור הגעה אוטומטי בקליק", icon: <IconCheck size={18} /> },
    { text: "גביית מקדמות בוואטסאפ", icon: <IconBolt size={18} /> },
    { text: "תזכורות אישיות לכל לקוח", icon: <IconBellRinging size={18} /> },
    { text: "הודעות דיוור בוואטסאפ", icon: <IconMessageChatbot size={18} /> },
    { text: "קמפיינים שיווקים מותאמים אישית", icon: <IconSend size={18} /> },
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.image}>
        <MediaStage
          image={image}
          variant="photo"
          arrow
          sizes="(max-width: 800px) 90vw, 540px"
          alt="נייליסטית עובדת על לקוחה, ולצידה תזכורת וואטסאפ אוטומטית מ-QuickTor עם קישור לאישור הגעה"
        />
      </div>
      <div className={classes.body}>
        <Badge
          size="lg"
          variant="filled"
          color="green"
          className={classes.badge}
        >
          חסכון בזמן וכסף
        </Badge>

        <Title className={classes.title} order={2}>
          שקט נפשי אפס ביטולים
        </Title>
        <Text className={classes.description}>
          המערכת שדואגת שאף לקוח לא "ישכח" את התור שלו.
          תנו לאוטומציה החכמה שלנו לעבוד בשבילכם, כדי שאתם תוכלו להתרכז בלעשות כסף.
        </Text>

        <div className={classes.benefitsGrid}>
          {benefits.map((benefit, index) => (
            <div key={index} className={classes.benefitCard}>
              <div className={classes.iconContainer}>
                {benefit.icon}
              </div>
              <Text className={classes.benefitText}>
                {benefit.text}
              </Text>
            </div>
          ))}
        </div>

        <Box mt={30} style={{ textAlign: 'center' }}>
          <a href="/blog/whatsapp-appointment-management" className={classes.link}>
            גלו איך להכפיל את ההגעה לתורים &gt;&gt;
          </a>
        </Box>

        <Button
          className={classes.ctaButton}
          component="a"
          href={"https://app.quicktor.co.il"}
          leftSection={<IconBrandWhatsapp size={22} />}
        >
          חברו את הוואטסאפ שלכם עכשיו
        </Button>
      </div>
    </div>
  );
}

export default Section_whatsapp_reminder;
